import { ManholeViewStore } from "../estimating/Manhole/stores/ManholeViewStore";
import JobListViewStore from "../estimating/JobManagement/JobListViewStore";
import JobDetailViewStore from "../estimating/JobManagement/JobDetailViewStore";

const estimatingStoresList = [
  { name: "manholeViewStore", store: ManholeViewStore },
  { name: "jobListViewStore", store: JobListViewStore },
  { name: "jobDetailViewStore", store: JobDetailViewStore },
];

export default estimatingStoresList;
